import { render, staticRenderFns } from "./ReservationBranch.vue?vue&type=template&id=1b9bd8d2&scoped=true&"
import script from "./ReservationBranch.vue?vue&type=script&lang=js&"
export * from "./ReservationBranch.vue?vue&type=script&lang=js&"
import style0 from "./ReservationBranch.vue?vue&type=style&index=0&id=1b9bd8d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9bd8d2",
  null
  
)

export default component.exports